import React from "react"
import { Wave } from "react-animated-text"
import Aos from "aos"
import styles from "./TeamPage.module.css"
import Illustration from "../Mediallustration"
import "./TeamPage.css"
import "aos/dist/aos.css"
import { database } from "../../../../firebase"

const ContentTeam = () => {
  const [width, setWidth] = React.useState()
  React.useEffect(() => {
    setWidth(window.innerWidth)
  }, [])
  const updateDimensions = () => {
    setWidth(window.innerWidth)
  }
  const updateWidth = () => {
    setWidth(window.innerWidth)
  }

  React.useEffect(() => {
    window.addEventListener("resize", updateWidth)
    return () => {
      window.removeEventListener("resize", updateDimensions)
    }
  }, [width])

  React.useEffect(() => {
    Aos.init({ duration: 1200 })
  }, [])
  const [image, setimage] = React.useState([])

  React.useEffect(async () => {
    database.team
      .where("team", "==", "media")
      .orderBy("name", "asc")
      .onSnapshot((querySnapshot) => {
        const arr1 = []
        querySnapshot.forEach((doc) => {
          const { URL } = doc.data()
          arr1.push(URL)
        })
        setimage(arr1)
      })
  }, [])
  const text = `Media Management Team`
  return (
    <>
      <div className={styles.mainContainer}>
        <div className={styles.pageHeading}>
          <span className={styles.heading}>
            <Wave
              text={text}
              effect="stretch"
              iterations={1}
              effectChange={2}
            />
          </span>
        </div>
        <div className={styles.container}>
          {width > 768 && <Illustration />}
          <div className={styles.subContainer}>
            {width <= 768 && <Illustration />}

            <div className={styles.para}>
              You're going to implement numerous magical changes and
              mind-provoking thoughts with your words and sentences here. The
              work allotted under this vertical is fascinating. Suppose you're a
              part of this magical train. In that case, you're going to prepare
              excellent content for the Club in writing informative articles,
              preparing innosights materials, events descriptions,
              heart-reaching info to bring awareness of the Club's progress
              among our spectators' uncountable interesting tasks coming up.
            </div>
          </div>
        </div>
      </div>
      <section className="team" data-aos="fade-up">
        <h1 className="teamHeading" data-aos="fade-up">
          Core Team Members
        </h1>
        <div className="members">
          <div className="member" data-aos="fade-up">
            <img src={image[0]} alt="Sachin Kumar" />
            <div className="memberName">
              <span>Sachin Kumar</span>
            </div>
            <div className="status">
              <span>Media Manager</span>
            </div>
            <div className="memberPhone">7668033930</div>
          </div>
          <div className="member" data-aos="fade-up">
            <img src={image[3]} alt="Vedanth Powar" />
            <div className="memberName">
              <span>Vedanth Powar</span>
            </div>
            <div className="status">
              <span>Head</span>
            </div>
            <div className="memberPhone">7020807667</div>
          </div>
          <div className="member" data-aos="fade-up">
            <img src={image[1]} alt="Abhay Raj Singh " />
            <div className="memberName">
              <span>Abhay Raj Singh </span>
            </div>
            <div className="status">
              <span>Core team member</span>
            </div>
            <div className="memberPhone">8081192413</div>
          </div>
          <div className="member" data-aos="fade-up">
            <img src={image[2]} alt="Nitin Ranjan" />
            <div className="memberName">
              <span>Nitin Ranjan</span>
            </div>
            <div className="status">
              <span>Media Management Executive </span>
            </div>
            <div className="memberPhone">9508714932</div>
          </div>
          <div className="member" data-aos="fade-up">
            <img src={image[5]} alt="Sudarshan Yadav" />
            <div className="memberName">
              <span>Sudarshan Yadav</span>
            </div>
            <div className="status">
              <span>Media Manager</span>
            </div>
            <div className="memberPhone">8188883007</div>
          </div>
          <div className="member" data-aos="fade-up">
            <img src={image[4]} alt="Nupur Chavan" />
            <div className="memberName">
              <span>Nupur Chavan</span>
            </div>
            <div className="status">
              <span>Media manager</span>
            </div>
            <div className="memberPhone">9579742467</div>
          </div>
          <div className="member" data-aos="fade-up">
            <img src={image[6]} alt="Mithilesh" />
            <div className="memberName">
              <span>Mithilesh</span>
            </div>
            <div className="status">
              <span>Media Manager</span>
            </div>
            <div className="memberPhone">6309881816</div>
          </div>
        </div>
      </section>
    </>
  )
}

export default ContentTeam
